import GdsHouseholdModel from '~/glm/models/gds/gds-household-model';
import GdsInvitationModel from '~/glm/models/gds/gds-invitation-model';

export const getHouseholdWithInvitations = (id, weddingId) => {
  return new GdsHouseholdModel({
    id: '1',
    weddingId: weddingId,
    coupleNote: 'Staying at Highline Hotel',
    rsvpNote: 'Staying at Highline Hotel',
    people: [
      {
        id: '1',
        firstName: 'Example',
        lastName: 'Guest',
        isLeader: true,
        invitations: [
          {
            id: 1,
            eventId: id,
            guestId: 1,
          },
        ],
      },
      {
        id: '2',
        firstName: 'Example',
        lastName: 'Guest',
        isLeader: false,
        invitations: [
          new GdsInvitationModel({
            id: 1,
            eventId: id,
            guestId: 1,
          }),
        ],
      },
    ],
  });
};

export const getPlaceholderHousehold = userStore => {
  return new GdsHouseholdModel({
    id: '2',
    weddingId: userStore.weddingId,
    coupleNote: 'Staying at Highline Hotel',
    rsvpNote: 'Staying at Highline Hotel',
    people: [
      {
        id: '3',
        firstName: 'Example',
        lastName: 'Guest',
        isLeader: true,
      },
      {
        id: '4',
        firstName: 'Example',
        lastName: 'Guest',
        isLeader: false,
      },
    ],
  });
};
